import { useContext } from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { ProductIdType, ToolIdType } from '@adsk/alloy-provider';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';

type CurrentProductIdContextType = {
  productId?: ProductIdType;
};

type CurrentToolIdContextType = {
  toolId?: ToolIdType;
};

export const useUnsafeCurrentProductId = () => {
  const currentProductIdContext = useContext(
    getOrCreateGlobalContext<CurrentProductIdContextType>(
      CONTEXT_NAMES.CurrentProductIdContext,
    ),
  );
  return currentProductIdContext?.productId;
};

export const useUnsafeCurrentToolId = () => {
  const currentToolIdContext = useContext(
    getOrCreateGlobalContext<CurrentToolIdContextType>(
      CONTEXT_NAMES.CurrentToolIdContext,
    ),
  );
  return currentToolIdContext?.toolId;
};
